"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
var _urlUtils = require("../../common/utils/domain/urlUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const _require = require('@tencent/cms-design-component'),
  SceneChange = _require.SceneChange;
const formatSceneChange = (properties, options = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$list = properties.list,
    list = _properties$list === void 0 ? [] : _properties$list,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color;
  const postMessageUrl = (0, _urlUtils.getVideoIframeUrl)(options);
  const configuration = list.map((item, index) => {
    const _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$content = item.content,
      content = _item$content === void 0 ? '' : _item$content,
      _item$href = item.href,
      href = _item$href === void 0 ? '' : _item$href,
      _item$hrefText = item.hrefText,
      hrefText = _item$hrefText === void 0 ? '' : _item$hrefText,
      _item$logoImg = item.logoImg,
      logoImg = _item$logoImg === void 0 ? '' : _item$logoImg,
      _item$filedVideoBg = item.filedVideoBg,
      filedVideoBg = _item$filedVideoBg === void 0 ? '' : _item$filedVideoBg,
      _item$filedVideoList = item.filedVideoList,
      filedVideoList = _item$filedVideoList === void 0 ? '' : _item$filedVideoList;
    return {
      key: `${index + 1}`,
      title,
      content: formatUrlInText(content),
      href: formatUrlString(href),
      hrefText,
      logoImg,
      source: filedVideoBg,
      filedVideoBg,
      filedVideoList,
      postMessageUrl
    };
  });
  // console.log('render-formatSceneChange-after', configuration);
  return {
    modTitle,
    bgColor: color,
    configuration
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatSceneChange = formatSceneChange(data, {
        domains
      }),
      modTitle = _formatSceneChange.modTitle,
      configuration = _formatSceneChange.configuration,
      bgColor = _formatSceneChange.bgColor;
    // console.log('FormRender-SceneChange-data[data]-', configuration);
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色

    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_sceneChange', componentKey, modTitle])), /*#__PURE__*/React.createElement(SceneChange, {
      configuration: configuration,
      flexTitle: modTitle,
      style: bgStyle,
      lazyStatus: false
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
}